import { render, staticRenderFns } from "./SkillsPanel.vue?vue&type=template&id=24ba6495&scoped=true&"
import script from "./SkillsPanel.vue?vue&type=script&lang=js&"
export * from "./SkillsPanel.vue?vue&type=script&lang=js&"
import style0 from "./SkillsPanel.vue?vue&type=style&index=0&id=24ba6495&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba6495",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
